import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { noop, uniqueId } from 'lodash'
import PropTypes from 'prop-types'
import cc from 'classcat'

import { setBuyboxNotification } from '../../store/actions'
import { track } from '../../utils/tracking'
import compose from '../../utils/compose'
import translate from '../../utils/translate'
import withI18n from '../../components/withI18n'

export function AddToWishlistLinkRaw({
  children,
  className,
  locale,
  setBuyboxNotification,
  productId,
  quantity = 1,
  lineItemId,
  t,
  callAfterItemAddedToWishlist = noop,
  title,
}) {
  const [isWishlistBusy, setIsWishlistBusy] = useState(false)

  useEffect(() => {
    const handleWishlistSuccess = (event) => {
      const notification = {
        id: uniqueId(`${productId}-success-`),
        message: (
          <span>
            {t('notifications.productAddedToWishlist')}{' '}
            <a className="add-to-cart-notice-message-link" href={event.detail.wishlist}>
              {t('views.storefrontView.goToWishlistLink.label')}
            </a>
          </span>
        ),
        type: 'success',
      }
      callAfterItemAddedToWishlist()
      setBuyboxNotification(notification)
      setIsWishlistBusy(false)
    }
    const handleWishlistNoUser = (event) => {
      window.addEventListener('pagehide', () => setIsWishlistBusy(false))
      window.location.assign(event.detail.redirect)
    }

    window.eComEventTarget.addEventListener(`wishlist:success-${productId}`, handleWishlistSuccess)
    window.eComEventTarget.addEventListener(`wishlist:nouser-${productId}`, handleWishlistNoUser)
    return () => {
      window.eComEventTarget.removeEventListener(`wishlist:success-${productId}`, handleWishlistSuccess)
      window.eComEventTarget.removeEventListener(`wishlist:nouser-${productId}`, handleWishlistNoUser)
    }
  }, [productId, t, setBuyboxNotification, callAfterItemAddedToWishlist])

  const addToWishlist = () => {
    setIsWishlistBusy(true)

    track('wishlist:add', {
      locale,
      product: { productId, quantity },
      lineItemId,
    })
  }

  return (
    <button
      className={cc([className, { pending: isWishlistBusy }])}
      disabled={isWishlistBusy}
      onClick={addToWishlist}
      type="button"
      title={title}
    >
      {children}
    </button>
  )
}

AddToWishlistLinkRaw.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  isWishlistBusy: PropTypes.bool,
  locale: PropTypes.string.isRequired,
  setBuyboxNotification: PropTypes.func.isRequired,
  productId: PropTypes.string.isRequired,
  quantity: PropTypes.number,
  lineItemId: PropTypes.string,
  t: PropTypes.func.isRequired,
  callAfterItemAddedToWishlist: PropTypes.func,
  title: PropTypes.string,
}

export default compose(
  withI18n('shop'),
  translate(),
  connect(
    (state) => ({
      locale: state.getIn(['shop', 'locale']),
    }),
    { setBuyboxNotification },
  ),
)(AddToWishlistLinkRaw)
